<template>
  <li class="theme-toggle" id="theme-toggle" ref="themeToggle" @focusout="handleClickOutside">
    <button
      @click="handleToggleClick"
      class="btn-icon"
      :aria-expanded="isOpen.toString()"
      aria-controls="theme-dropdown-menu"
      aria-describedby="theme-toggle-description"
    >
      <i :class="selectedThemeIconClass" aria-hidden="true"></i>
      <span>{{ selectedThemeLabel }}</span>
      <i class="fas fa-caret-down" aria-hidden="true"></i>
    </button>
    <span id="theme-toggle-description" class="sr-only">Theme toggle</span>
    <ul id="theme-dropdown-menu" class="dropdown k-menu-panel" :class="[{ 'is-open': isOpen }]" :hidden="!isOpen">
      <li v-for="(theme, key) in themes" :key="key" class="k-menu-item">
        <button type="button" @click="selectTheme(key)">
          <i :class="theme.iconClass" aria-hidden="true"></i>
          <span>{{ theme.label }}</span>
        </button>
      </li>
    </ul>
  </li>
</template>

<style scoped>
.theme-toggle .dropdown {
  min-width: 135px;
}

@media (min-width: 768px) and (max-width: 1084px) {
  #theme-toggle .dropdown {
    left: 50%;
    transform: translate(-54%, -8px);
  }

  #theme-toggle .dropdown.is-open {
    left: 50%;
    transform: translate(-54%, 0);
  }
}
</style>

<style>
@media (min-width: 768px) and (max-width: 1084px) {
  #theme-toggle .btn-icon .fa-caret-down {
    display: none;
  }
}
</style>

<script>
import useThemeStore from '@stores/theme';

export default {
  beforeMount() {
    this.selectedTheme = this.themeStore.theme;
  },

  mounted() {
    this.$survey.init();
    document.addEventListener('click', this.handleClickOutside);
  },

  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },

  data() {
    return {
      themeStore: useThemeStore(),
      isOpen: false,
      themes: {
        light: { iconClass: 'fa-duotone fa-sun', label: 'Light' },
        dark: { iconClass: 'fa-duotone fa-moon-stars', label: 'Dark' },
        legacy: { iconClass: 'fa-duotone fa-building-columns', label: 'Legacy' },
      },
      selectedTheme: null,
    };
  },

  computed: {
    selectedThemeIconClass() {
      return this.themes[this.selectedTheme]?.iconClass || 'fa-duotone fa-eclipse';
    },

    selectedThemeLabel() {
      return this.themes[this.selectedTheme]?.label || 'Theme';
    },
  },

  methods: {
    handleToggleClick() {
      this.isOpen = !this.isOpen;
      this.$survey.trackAction('theme_toggle_click');
    },

    selectTheme(theme) {
      this.selectedTheme = theme;
      this.themeStore.theme = this.selectedTheme;
      this.updateFrontendSettings(true);
      this.isOpen = false;
    },

    handleClickOutside(event) {
      const themeToggle = this.$refs.themeToggle;
      const target = event.type === 'focusout' ? event.relatedTarget : event.target;
      if (themeToggle && !themeToggle.contains(target)) {
        this.isOpen = false;
      }
    },

    updateFrontendSettings(showToast) {
      return this.$http.put('/api/profile/user/frontend_settings', {
        theme: this.selectedTheme,
        hide_themes_popup: this.themeStore.hideThemesPopup,
        hide_chatbot_popup: this.themeStore.hideChatBotPopup,
      }).then(() => {
        if (showToast) {
          this.$ktoast.success('Theme preference saved');
        }
        this.$logger.info('User preference saved');
      }).catch(err => {
        this.$logger.warn('Error saving user preference for user', undefined, err);
      });
    },
  },
};
</script>
